"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPages = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _utils = require("composer-lib/lib/utils");

var _PagesManager = require("composer-lib/data/PagesManager");

var fetchPagesPending = (0, _utils.createAction)(_ActionTypes.default.FETCH_PAGES_PENDING);
var fetchPagesSucceeded = (0, _utils.createAction)(_ActionTypes.default.FETCH_PAGES_SUCCEEDED);
var fetchPagesFailed = (0, _utils.createAction)(_ActionTypes.default.FETCH_PAGES_FAILED);

var fetchPages = function fetchPages(compositionType) {
  return function (dispatch) {
    dispatch(fetchPagesPending());
    (0, _PagesManager.fetch)(compositionType).then(function (resp) {
      return dispatch(fetchPagesSucceeded(resp));
    }, function (resp) {
      return dispatch(fetchPagesFailed(resp));
    });
  };
};

exports.fetchPages = fetchPages;